// removed by extract-text-webpack-plugin
module.exports = {"h1":"H1__h1"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/typography/H1/H1.tablet.css
// module id = 1352
// module chunks = 8